/* eslint-disable jsx-a11y/label-has-associated-control */
import classnames from 'classnames';
import {
	Alert, Button, connectedComponent, LoadingIndicator, Modal
} from 'gwx-voyager-components';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { loadPreferences } from './preferences.actions';

/**
 * Component for Unsubscribe - Unsubscribing from notifications
 *
 * @class Unsubscribe
 * @extends {Component}
 */
class Unsubscribe extends Component {
	constructor(props) {
		super(props);
		this.state = {
			buttonsDisabled: false,
			errorMsg: null,
			prefs: this.props.preferences[0]
		};
	}

	componentDidMount() {
		const query = {
			communityId: this.props.communityId,
			subscriptionId: this.props.subscriptionId
		};
		this.props.fetchPreferences(query);
	}

	componentDidUpdate(prevProps) {
		if (this.props.preferences[0] !== prevProps.preferences[0]) {
			// eslint-disable-next-line react/no-did-update-set-state
			this.setState({
				prefs: this.props.preferences[0],
				errorMsg: this.props.preferences[0].errorMsg,
				buttonsDisabled: false
			});
		}
	}

	render() {
		let modalUnsubscribeContent = null;
		let providerDetails = null;
		let alert = null;

		if (this.props.isFetching || !this.state.prefs) {
			modalUnsubscribeContent = (<LoadingIndicator />);
		} else {
			const { prefs } = this.state;

			if (prefs.providerName && prefs.sendingFacilityDisplayName) {
				providerDetails = (
					<div className='mb-3'>
						<div>
							<b>Name: </b>
							{prefs.providerName}
						</div>
						<div>
							<b>Sending Facility: </b>
							{prefs.sendingFacilityDisplayName}
						</div>
						<div>
							<b>Direct Address: </b>
							{prefs.directAddress}
						</div>
					</div>
				);
			}

			if (this.state.errorMsg) {
				const alertProps = {
					children: this.state.errorMsg,
					type: 'danger',
					visible: true,
					dismissable: false
				};
				alert = <Alert {...alertProps} />;
			}

			const subscribeContent = (
				<div className='mt-3 mb-3'>
					Are you sure you want to unsubscribe the provider from the
					{' '}
					{prefs.sendingFacilityDisplayName}
					{' '}
					Facility?
				</div>
			);

			const content = (
				<div>
					{providerDetails}
					{subscribeContent}
				</div>
			);

			modalUnsubscribeContent = (
				<div className='unsubscribe'>
					<div className={classnames({ container: !this.state.linkedFromUnsubscribe })}>
						{alert}
						{content}
					</div>
				</div>
			);
		}

		return (
			<Modal
				title='Unsubscribe Provider'
				content={modalUnsubscribeContent}
				show
				classNames='unsubscribeModal'
				onClose={() => this.props.onPreferencesModalClose()}
				closeLabel='Cancel'
				buttons={[
					<Button
						id='unsubscribe'
						key='unsubscribe'
						className='btn-success'
						disabled={this.state.buttonsDisabled}
						onClick={() => this.props.onClickOptOut()}
					>
						Confirm
					</Button>]}
			/>
		);
	}
}

Unsubscribe.propTypes = {
	communityId: PropTypes.string,
	subscriptionId: PropTypes.string,
	sendingFacilityDisplayName: PropTypes.string,
	fetchPreferences: PropTypes.func.isRequired,
	onClickOptOut: PropTypes.func.isRequired,
	onPreferencesModalClose: PropTypes.func.isRequired,
	isFetching: PropTypes.bool.isRequired
};

/**
 * Maps the redux store's state to a set of props to be
 * passed to the Unsubscribe component.
 *
 * @param {object} state
 * 		The current state of the redux store.
 */
const mapStateToProps = (state) => {
	const {
		entities: { preferences }
	} = state;

	return {
		isFetching: preferences.isFetching,
		preferences: preferences.ids.map((id) => preferences.results[id]),
		component: 'preferences'
	};
};

const mapDispatchToProps = (dispatch) => ({
	fetchPreferences: (query) => { dispatch(loadPreferences(query)); }
});

const UnsubscribeContainer = connectedComponent(Unsubscribe, mapStateToProps, mapDispatchToProps);

export { UnsubscribeContainer as default, Unsubscribe };
